import React from 'react'
import ProtectedRoute from '../../internal/ProtectedRoute'
import NewsContainer from './NewsContainer'
import AdminNewsContainer from './AdminNewsContainer'
import EditNewsContainer from './Edit/EditNewsContainer'
import { Authorities } from '../../models/authorities'

const NewsRoutes = () => (
  <div>
    <ProtectedRoute
      key="/news"
      exact
      path="/news"
      authority={Authorities.MESSAGING}
      page={<NewsContainer />}
    />
    <ProtectedRoute
      key="/news/admin"
      exact
      path="/news/admin"
      authority={Authorities.NEWS_AUTHOR}
      page={<AdminNewsContainer />}
    />
    <ProtectedRoute
      key="/news/admin/edit"
      exact
      path="/news/admin/edit"
      authority={Authorities.NEWS_AUTHOR}
      page={<EditNewsContainer />}
    />
  </div>
)

export default NewsRoutes
